module.exports = __webpack_public_path__ + "img/station_logoLeft.115d783e.png";